import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="relative">
      <Icon
        name="MagnifyingGlassIcon"
        size={20}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground"
      />
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search resources by title, description, or category..."
        className="w-full pl-12 pr-4 py-3 bg-card border border-border rounded-lg font-body text-sm text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200"
      />
    </div>
  );
};

export default SearchBar;